<template>
  <div class="page">
    <div class="exchange_wrapper">
      <!--div class="exchange_user_wrapper">
        <div class='exchange_user'>
         <img src='https://wx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTIavBvxZz8M4anQlf7K5OIhJ9cH2kG09fyybYZNJds6fqEibHzC1KxOJPMX4UQ87ZJ8Vj1UDPfibAMA/0' class='exchange_avata' />@＊＊美 5分钟前兑换柑橘一份
       </div
      </div>-->
        <div class='my_coins'>
         <div>当前{{scoreUserInfo.totalScore?scoreUserInfo.totalScore-scoreUserInfo.usedScore:0}}券币</div>
         <router-link class="my_coins_ways" to="/userCenter/getCoinsWays"><span class=' icon-notice icon_notice'></span>如何赚券币</router-link>
       </div>
    </div>
    <!--兑换商品列表页-->
    <mallList></mallList>
    <router-link to="/userCenter/buyScoreMallGoodRecord" class="my_exchange">我的兑换记录</router-link>
  </div>
</template>

<script type="text/ecamscript-6">
import MallList from '@/components/userCenter/mall/mallList'
  export default {
    name:"mall",
    components:{
      'mallList':MallList
    },
    computed:{
      scoreUserInfo: function() {
        return this.$store.state.scoreUserInfo
      },
    }
  }
</script>
<style lang="stylus">
  .page
    background:#f94952
    padding:30px 0
    .exchange_wrapper
      width:750px
      height:369px
      background:url(../../../images/qb_bg.jpg)no-repeat left top
      background-size:750px 369px
      position:relative
      .exchange_user_wrapper
        position: absolute
        left: 20px
        top: 15px
        background: rgba(0,0,0,0.2)
        height: 58px
        border-radius: 29px
        padding: 4px 40px 4px 4px
        box-sizing: border-box
        .exchange_user
          line-height: 50px
          font-size: 24px
          color: #fff751
          .exchange_avata
            width: 50px
            height: 50px
            box-sizing: border-box
            border-radius: 25px
            vertical-align: middle
            margin-right: 10px
            border: 1px solid #fff
            /*px*/
      .my_coins
        width:100%
        display: flex
        justify-content: space-around
        color: #fff
        font-size: 28px
        line-height: 40px
        vertical-align: middle
        position:absolute
        left:0px
        bottom:0px
        .my_coins_ways
          color: #fff
          font-size: 28px
          .icon_notice
            margin-right:10px
    .my_exchange
      width:400px
      height:88px
      background: linear-gradient(to right,#ff6f25,#ff0026);
      border-radius:44px
      position:fixed
      bottom:130px
      left:50%
      transform:translateX(-50%)
      font-size:40px
      line-height:88px
      color:#fff
      text-align:center


</style>



// WEBPACK FOOTER //
// src/components/userCenter/mall/mall.vue